import translateService from '../../../utils/translateService';
import { formatOrdinals } from '../../FormRadio/helpers';

export const getDate = (selectedSlot: Record<string, any>) => {
  const { t, language } = translateService.get();
  const date = new Date(selectedSlot?.date?.fullDate) || new Date();
  const time = selectedSlot.time || '12:00 AM';
  const month = date.toLocaleString(navigator.language || 'en-GB', {
    month: 'long'
  });
  const day = date.toLocaleString(navigator.language || 'en-GB', {
    day: 'numeric'
  });

  return `${formatOrdinals(Number(day), language)} ${t('of')} ${month} ${t('at')} ${time}`;
};
